import React, { Component, Fragment } from 'react'
import ReactHtmlParser from 'react-html-parser';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Config } from '../config';


const Context = React.createContext();

const LanguageConsumer =  Context.Consumer;

let languageFile = Config.language.defaultFile;

class LanguageProvider extends Component {
    constructor(props) {
        super(props)
        this.state = {
            language: Config.language.default
        }
        this.onChangeLanguage = this.onChangeLanguage.bind(this);
    }
    componentDidMount() {
        this.setLanguage(localStorage.getItem('language') || this.state.language);
    }
    onChangeLanguage(language) {
        this.setLanguage(language);
    }
    setLanguage(language) {

        this.setState({ language });
        localStorage.setItem('language', language);

        try {
            languageFile = require('../assets/lang/' + language);
        } catch (e) {
            languageFile = Config.language.defaultFile;
        }

    }
    render() {
        return (
            <Context.Provider value={{
                language: this.state.language,
                onChangeLanguage: this.onChangeLanguage
            }}>
                {this.props.children}
            </Context.Provider>
        )
    }
}


const Translate = (text) => {
    return (ReactHtmlParser(languageFile[text] || SetLanguageFile(text)))
}

const TranslateExt = (text) => (
    <LanguageConsumer>
        {() => (Translate(text))}
    </LanguageConsumer>
)

class LanguageList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            dropdownLanguage: false
        }
    }
    toggleLanguage() {
        this.setState(prevState => ({
            dropdownLanguage: !prevState.dropdownLanguage
        }));
    }
    render() {

        return (
            <LanguageConsumer>
                {({ language, onChangeLanguage }) => {

                    let active = Config.language.list.filter(item => item.key === language).map(item => (
                        <Fragment key={item.key}>
                            <img src={"/assets/images/flags/" + item.icon} className="mr-2" height="16" alt="" /> {item.text}  &nbsp; <span className="mdi mdi-chevron-down"></span>
                        </Fragment>
                    ));

                    let list = Config.language.list.map(item => (<button type="button" key={item.key} className={"dropdown-item " + (language === item.key ? 'active' : '')} onClick={(e) => { onChangeLanguage(item.key); this.toggleLanguage(); }}><img src={"/assets/images/flags/" + item.icon} alt="" height="24" /><span> {item.text} </span></button>))

                    return (
                        <Dropdown isOpen={this.state.dropdownLanguage} toggle={(e) => this.toggleLanguage()}>
                            <DropdownToggle className="nav-link nav-link-login dropdown-toggle arrow-none testflag waves-effect" caret tag="a">
                                {active}
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu dropdown-menu-right language-switch">
                                {list}
                            </DropdownMenu>
                        </Dropdown>
                    )
                }}
            </LanguageConsumer>)
    }
}


//TODO: yayına alınmadan önce kaldırılacak.
const SetLanguageFile = (text) => {

    let languageFile = (JSON.parse(localStorage.getItem("languageFile")) || {});
    languageFile[text] = text;

    try {
        localStorage.setItem("languageFile", JSON.stringify(languageFile));
    } catch (error) {

    }

    return text;
}


export { LanguageConsumer, LanguageProvider, Translate, TranslateExt, LanguageList }